<div class="d-flex flex-column gap-4" [class.opacity-50]="disabled">
  <div class="d-flex align-items-center">
    <div class="responsive-card-title flex-grow-1" i18n>Relationship Status</div>
    <app-edit-button [disabled]="disabled" (clicked)="editClicked.emit()" />
  </div>
  <div class="entry-grid">
    <app-review-entry label="Relationship Status" i18n-label [value]="relationshipStatus?.type?.name" />
    <app-relationship-effective-date-review-entry [relationshipStatus]="relationshipStatus" />
  </div>
</div>
